import { Box, Paper, Slide } from "@suid/material";
import createElementRef from "@suid/system/createElementRef";
import { onMount, type ParentComponent } from "solid-js";
import type { SnackbarProps } from ".";

// Until https://github.com/swordev/suid/issues/128 is implemented: use a somewhat compatible home grown version.
export const Snackbar: ParentComponent<SnackbarProps> = (props) => {
    const element = createElementRef();
    const Container = props.children ?? <Paper elevation={5} sx={{ p: 2 }}>{props.message}</Paper>;

    onMount(() => {
        if (props.autoHideDuration) {
            setTimeout(() => props.onClose?.(undefined, "timeout"), props.autoHideDuration);
        }
    });

    return (
        <Box
            ref={element}
            sx={{ m: 0, position: "fixed", bottom: 0, right: 0, zIndex: 100 }}
        >
            <Slide
                direction="up"
                in={props.open}
            >
                <Box sx={{ m: 2 }}>
                    {Container}
                </Box>
            </Slide>
        </Box>
    );
};
